import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import VaultAmountDetails from "../VaultAmountDetails";
import ModelProxyClass from "./ModelProxyClass";
import AmountDetails from "../AmountDetails";


/**
 * @class VaultAmountDetailsBase
 * @extends ModelBaseClass
 * @property {number} strappedAmount
 * @property {AmountDetails} strappedDetails
 * @property {number} looseAmount
 * @property {AmountDetails} looseDetails
 * @property {number} unfitAmount
 * @property {AmountDetails} unfitDetails
 */
class VaultAmountDetailsBase extends ModelBaseClass {
	/**
	 * @type {number} strappedAmount
	 */
	strappedAmount;
	/**
	 * @type {AmountDetails} strappedDetails
	 */
	strappedDetails;
	/**
	 * @type {number} looseAmount
	 */
	looseAmount;
	/**
	 * @type {AmountDetails} looseDetails
	 */
	looseDetails;
	/**
	 * @type {number} unfitAmount
	 */
	unfitAmount;
	/**
	 * @type {AmountDetails} unfitDetails
	 */
	unfitDetails;

	/**
	 * Instantiates a new instance of VaultAmountDetails based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {VaultAmountDetails}
	 */
	static create(genericObject) {
		const newVaultAmountDetails = new VaultAmountDetails();
		newVaultAmountDetails.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newVaultAmountDetails;
	}

	/**
	 * Instantiates a new array of VaultAmountDetails based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[VaultAmountDetails]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newVaultAmountDetailsArray = [];
		genericArray.forEach(genericObject => {
			newVaultAmountDetailsArray.push(VaultAmountDetails.create(genericObject));
		});
		return newVaultAmountDetailsArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('strappedAmount', 'float'),
	ModelBaseClass.createModelProperty('strappedDetails', 'AmountDetails'),
	ModelBaseClass.createModelProperty('looseAmount', 'float'),
	ModelBaseClass.createModelProperty('looseDetails', 'AmountDetails'),
	ModelBaseClass.createModelProperty('unfitAmount', 'float'),
	ModelBaseClass.createModelProperty('unfitDetails', 'AmountDetails'),
];

export default VaultAmountDetailsBase;
